// extracted by mini-css-extract-plugin
module.exports = {"LoadError":"oe_a pz_mo pz_a pz_w pz_j pz_q","LoadError__icon":"oe_b pz_qw pz_fa pz_oj","LoadError__message":"oe_c pz_fa pz_pe"};